var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "materialReceiveRefundDrawer" },
    [
      _c(
        "div",
        { staticClass: "con__style" },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "form",
              attrs: { model: _vm.form, "label-width": "110px", size: "small" },
            },
            [
              _c("div", { staticClass: "section-title" }, [_vm._v("基本信息")]),
              _c(
                "div",
                { staticStyle: { display: "flex", "flex-wrap": "wrap" } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { flex: "1", "min-width": "300px" },
                      attrs: {
                        label: _vm.isRefund ? "退还人" : "领用人",
                        prop: "user_name",
                      },
                    },
                    [
                      _c("el-input", {
                        staticClass: "input__width",
                        attrs: { disabled: "", placeholder: "-" },
                        model: {
                          value: _vm.form.user_name,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "user_name", $$v)
                          },
                          expression: "form.user_name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: {
                        flex: "1",
                        "min-width": "300px",
                        "margin-left": "20px",
                      },
                      attrs: {
                        label: _vm.isRefund ? "退还日期" : "领取日期",
                        prop: "date",
                        rules: [
                          {
                            required: true,
                            message: "请选择退还日期",
                            trigger: "change",
                          },
                        ],
                      },
                    },
                    [
                      _c("el-date-picker", {
                        staticClass: "input__style",
                        attrs: {
                          type: "date",
                          "value-format": "yyyy-MM-dd",
                          format: "yyyy-MM-dd",
                          placeholder: "请选择",
                        },
                        model: {
                          value: _vm.form.date,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "date", $$v)
                          },
                          expression: "form.date",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticStyle: { display: "flex", "flex-wrap": "wrap" } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { flex: "1 1 100%" },
                      attrs: {
                        label: _vm.isRefund ? "退还备注" : "领用备注",
                        prop: "remark",
                      },
                    },
                    [
                      _c("el-input", {
                        staticClass: "input__width",
                        attrs: {
                          type: "textarea",
                          autosize: { minRows: 4, maxRows: 100 },
                          maxlength: 500,
                          "show-word-limit": "",
                          disabled: !_vm.isRefund,
                          placeholder: "请输入",
                        },
                        model: {
                          value: _vm.form.remark,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "remark", $$v)
                          },
                          expression: "form.remark",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("el-divider", { staticStyle: { margin: "20px 0" } }),
              _c(
                "div",
                { staticClass: "section-title" },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.isRefund ? "退还物料明细" : "领取物料明细") +
                      " "
                  ),
                  !_vm.isRefund
                    ? _c(
                        "el-button",
                        {
                          staticStyle: { "margin-left": "20px" },
                          attrs: {
                            type: "primary",
                            size: "mini",
                            icon: "el-icon-plus",
                          },
                          on: { click: _vm.handleAddMaterial },
                        },
                        [_vm._v("添加物料")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%", margin: "10px 0 50px 0" },
                  attrs: {
                    border: "",
                    "header-cell-style": {
                      background: "#F1F1F1",
                      color: "#333333",
                    },
                    data: _vm.form.material_items,
                    "tooltip-effect": "dark",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: "序号",
                      width: "60px",
                      type: "index",
                      align: "left",
                    },
                  }),
                  _vm.isRefund
                    ? _c("el-table-column", {
                        attrs: {
                          label: "物料领取ID",
                          width: "120px",
                          prop: "id",
                          align: "left",
                        },
                      })
                    : _vm._e(),
                  _c("el-table-column", {
                    attrs: {
                      label: "物料编码",
                      width: "110px",
                      prop: "material_id",
                      align: "left",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "物料名称",
                      "min-width": "150px",
                      prop: "name",
                      align: "left",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "物料类型",
                      width: "100px",
                      prop: "material_type_des",
                      align: "left",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "工艺材质",
                      width: "100px",
                      prop: "craft_type_des",
                      align: "left",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "规格",
                      width: "120px",
                      prop: "attribute_str",
                      align: "left",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "印刷类型",
                      width: "100px",
                      prop: "print_type_des",
                      align: "left",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "领取仓库", width: "120px", align: "left" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  scope.row.branch_office_name ||
                                    scope.row.city_name ||
                                    "-"
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm.isRefund
                    ? [
                        _c("el-table-column", {
                          attrs: {
                            label: "领取数量",
                            width: "100px",
                            prop: "receive_num",
                            align: "left",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: "已退还数量",
                            width: "130px",
                            prop: "refund_num",
                            align: "left",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: "可退还数量",
                            width: "100px",
                            align: "left",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.getReturnableNum(scope.row)
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            503762226
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: "本次退还数量",
                            width: "140px",
                            align: "left",
                            fixed: "right",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-form-item",
                                      {
                                        staticStyle: { "margin-bottom": "0" },
                                        attrs: {
                                          prop:
                                            "material_items." +
                                            scope.$index +
                                            ".num",
                                          rules: [
                                            {
                                              required: true,
                                              message: "请输入退还数量",
                                              trigger: "change",
                                            },
                                            {
                                              pattern: /^[1-9]\d*$/,
                                              message: "请输入正整数",
                                              trigger: "change",
                                            },
                                            {
                                              validator: function (
                                                rule,
                                                value,
                                                callback
                                              ) {
                                                _vm.validateReturnNum(
                                                  rule,
                                                  value,
                                                  callback,
                                                  scope.row
                                                )
                                              },
                                              trigger: "change",
                                            },
                                          ],
                                          "label-width": "0",
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            placeholder: "请输入",
                                            size: "mini",
                                          },
                                          model: {
                                            value: scope.row.num,
                                            callback: function ($$v) {
                                              _vm.$set(scope.row, "num", $$v)
                                            },
                                            expression: "scope.row.num",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            818132587
                          ),
                        }),
                      ]
                    : [
                        _c("el-table-column", {
                          attrs: {
                            label: "申请数量",
                            width: "100px",
                            prop: "apply_num",
                            align: "left",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: "库存",
                            width: "100px",
                            prop: "stock_count",
                            align: "left",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: "领取数量",
                            width: "140px",
                            align: "left",
                            fixed: "right",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticStyle: { "margin-bottom": "0" },
                                      attrs: {
                                        prop:
                                          "material_items." +
                                          scope.$index +
                                          ".num",
                                        rules: [
                                          {
                                            required: true,
                                            message: "请输入领取数量",
                                            trigger: "change",
                                          },
                                          {
                                            pattern: /^[1-9]\d*$/,
                                            message: "请输入正整数",
                                            trigger: "change",
                                          },
                                        ],
                                        "label-width": "0",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          placeholder: "请输入",
                                          size: "mini",
                                        },
                                        model: {
                                          value: scope.row.num,
                                          callback: function ($$v) {
                                            _vm.$set(scope.row, "num", $$v)
                                          },
                                          expression: "scope.row.num",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: "操作",
                            width: "100px",
                            align: "left",
                            fixed: "right",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-button",
                                    {
                                      staticStyle: { color: "red" },
                                      attrs: { type: "text" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleRemove(scope.$index)
                                        },
                                      },
                                    },
                                    [_vm._v("移除")]
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: {
                type: "primary",
                size: "small",
                loading: _vm.submitLoading,
              },
              on: { click: _vm.handleSubmit },
            },
            [_vm._v("提交")]
          ),
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.handleClose } },
            [_vm._v("取消")]
          ),
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.drawerSelect,
            size: "75%",
            title: "添加物料",
            "append-to-body": true,
            "custom-class": "myDrawer",
            "destroy-on-close": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawerSelect = $event
            },
          },
        },
        [
          _c("material-select-drawer", {
            on: {
              selected: _vm.handleMaterialSelected,
              close: function ($event) {
                _vm.drawerSelect = false
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }